/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-explicit-any */
import ReactECharts from "echarts-for-react";
import CardLayout from "../Cards/CardLayout";
import { useFetchData } from "../../customHooks/useGetDashboardData";

import CardError from "../feedBacks/CardError";
import Loader from "../feedBacks/loader";
import NoContent from "../feedBacks/NoContent";
import { EChartsOption } from "echarts";
import { REFETCH_CONFIGURATION } from "../../utils/constants";
import { useAppSelector } from "../../store/hooks";
import { createToolboxConfig} from "../../utils/utils";
import NoDeviceCardError from "../feedBacks/NoDeviceCardError";
import { useUtils } from "../../customHooks/useUtils";


type SiteMonitoredData = {
  total: number;
  dataset: { key: string; value: number }[];
};

const SiteMonitoredChart = ({
  company_id,
}: {
  total?: string;
  totalText?: string;
  company_id: string;
  }) => {
  const { FEEDBACK_MESSAGES, t } = useUtils();
  const startDate = useAppSelector((state) => state.filter.startDate);
  const endDate = useAppSelector((state) => state.filter.endDate);
  const { data, isLoading, error } = useFetchData(
    ["/operations", "fetchSiteMonitored", company_id],
    "/operations/sites-monitored",
    {
      company_id,
      start_date: startDate,
      end_date: endDate,
    },
    // @ts-ignore
    {
      ...REFETCH_CONFIGURATION,
    }
  );
  const transformedData = (data as SiteMonitoredData) || {
    total: 0,
    dataset: [],
  };
  // const totalValue = transformedData?.dataset.reduce(
  //   (sum: any, item: any) => sum + item.value,
  //   0
  // );
  const getValueFromKey = (key: string) => {
 switch (key) {
    case "active":
      return t("common.active");
    case "offline":
      return t("common.offline");
    default:
      return key;
  }
};
  const options: EChartsOption = {
    ...createToolboxConfig({
      chartName: t("chart.site_monitored"),
      top: "0px",
      right: "5px",
    }),
    legend: {
      top: "80%",
      left: "center",
      data: transformedData?.dataset?.map(
        (item: any) => `${getValueFromKey(item.key)} (${item.value})`
      ), // Append percentage to legend name
    },
    series: [
      {
        type: "pie",
        data: transformedData?.dataset?.map((item: any) => ({
          ...item,
          name: `${getValueFromKey(item.key)} (${item.value})`, // Add percentage to name
          itemStyle: {
            borderRadius: 10,
            borderColor: "#fff",
            borderWidth: 6,
            color: item.key.includes("active") ? "#FFC000" : "#7C878E", // Pie chart segment color
          },
        })),
        radius: ["40%", "70%"],
        center: ["50%", "35%"],
        avoidLabelOverlap: false,
        label: {
          show: false,
          position: "center",
        },
        emphasis: {
          label: {
            show: true,
            fontSize: "20",
            fontWeight: "bold",
          },
        },
        labelLine: {
          show: false,
        },
      },
    ],
  };

  return (
    <CardLayout
      title={t("chart.site_monitored")}
      className="min-w-[300px] lg:max-w-[450px] flex-1"
    >
      <div className="flex flex-col h-full w-full relative">
        {isLoading ? (
          <div className="flex justify-center items-center h-full w-full">
            <Loader />
          </div>
        ) : error ? (
          (error as any).response.data.detail ? (
            <NoDeviceCardError
              message={FEEDBACK_MESSAGES.NO_DEVICE}
              className="!max-h-[150px]"
            />
          ) : (
            <CardError
              message={FEEDBACK_MESSAGES.ERROR}
              className="!h-[100px]"
            />
          )
        ) : transformedData.total ? (
          <>
            <div className="absolute inset-0 top-[-15%] h-full flex  flex-col items-center justify-center">
              <span className="text-3xl font-semibold">
                {transformedData.total}
              </span>
              <span className="text-md font-semibold">
                {t("site_details.location")}
              </span>
            </div>
            <ReactECharts option={options} />
          </>
        ) : (
          <NoContent message={FEEDBACK_MESSAGES.NO_DATA} />
        )}
      </div>
    </CardLayout>
  );
};

export default SiteMonitoredChart;
